export default class BastaError extends Error {
  constructor(errorName, message) {
    super(message)
    this.name = errorName
  }
}
